import { createSelector } from '@reduxjs/toolkit';
import type { WCmsPageSummaryView } from '@zola/svc-web-api-ts-client';
import { RootState } from '../reducers';

export const getPageSummariesById = (state: RootState): Record<string, WCmsPageSummaryView> => {
  return state.weddingWebsite.pageSummariesById;
};

export const getRegistryPageSummary = createSelector(
  getPageSummariesById,
  (summaries) => summaries.REGISTRY
);
